/**
 * Mixin xử lý validate combobox
 */
import i18nValidate from '@/i18ns/vi/i18nValidate';
export const validateCombobox = {
  /**
   * @override
   */
  validateRule(rule, editor) {
    const me = this;
    let res = true;
    let message = '';
    const titleError = editor.getTitleError();
    switch (rule) {
      case 'forceSelection':
        if (!me.validateForceSelection(editor)) {
          message = i18nValidate.messages[rule](titleError);
        }

        break;
      case 'notSelectParent':
        if (!me.validateNotSelectParent(editor)) {
          message = i18nValidate.messages[rule](titleError);
        }
        break;
      case 'required':
        const controlValue = editor.getValue();
        if (
          controlValue === undefined ||
          controlValue === null ||
          controlValue === NaN ||
          controlValue === ''
        ) {
          message = i18nValidate.messages[rule](titleError);
        }
        break;
    }

    return message;
  },

  /**
   * Xử lý force selection
   * @param {*} editor
   * @returns
   * HTHIEP 01.07.2022: Sửa lại việc lấy item theo text => case thêm trường hợp có suffix
   */
  validateForceSelection(editor) {
    const me = this;
    if (editor && editor.internalText) {
      //nếu là binding trên grid
      if (
        editor.$cell &&
        editor.queryMode === 'remote' &&
        !editor.lastRequestParam
      ) {
        return true;
      }

      let dataSource = editor.internalDataSource;

      //nếu là binding thì trả về true
      // pvduy 29/06/2021: sửa lỗi khi hủy form thêm mới trên combobox thì ko cảnh báo.
      if (
        editor.internalText === editor.initText &&
        dataSource.length === 0 &&
        (!me.forceSelection || me.internalValue)
      ) {
        return true;
      }

      if (dataSource && dataSource.length > 0) {
        if (editor.value) {
          return true;
        }
        let valueText = editor.internalText;
        let items = editor.findItemByText(valueText);
        if (items && items.length) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
    return true;
  },
  /**
   * ĐVThi 05/02/2020: Validate bắt buộc chọn con, không được chọn cha
   */

  validateNotSelectParent(editor) {
    if (editor) {
      let item = editor.internalSelectedItem;
      if (item && item.hasOwnProperty('isParent') && item['isParent']) {
        return false;
      }
    }
    return true;
  }
};
